<template>
  <a :href="value.href">{{ value.content }}</a>
</template>

<script>
export default {
  props: ['value'],
};
</script>
